import request from './request';

export function getSalt(username) {
  return request.get(`/auth/${username}/salt`);
}
export function login(data, username) {
  return request.post(`/auth/${username}/login`, data);
}
export function token2Login(data) {
  return request.post(`/auth/token2Login`, data);
}
